module.exports = __webpack_public_path__ + "fonts/iconfont.c8c25fdc.ttf";